<template>
  <div class="w-full">
    <h4 class="font-bold">How would you like to pay?</h4>

    <div class="flex space-x-2 mt-3">
      <div>
        <img
          src="//t-ec.bstatic.com/static/img/payments/payment_icons_redesign/amex.svg"
          alt="American Express"
          title="American Express"
          aria-hidden="false"
          height="18"
          width="30"
        />
      </div>
      <div>
        <img
          src="//t-ec.bstatic.com/static/img/payments/payment_icons_redesign/visa.svg"
          alt="Visa"
          title="Visa"
          aria-hidden="false"
          height="18"
          width="30"
        />
      </div>
      <div>
        <img
          src="//t-ec.bstatic.com/static/img/payments/payment_icons_redesign/mc.svg"
          alt="MasterCard"
          title="MasterCard"
          aria-hidden="false"
          height="18"
          width="30"
        />
      </div>
    </div>

    <div class="vx-row my-8">
      <!-- First name  -->
      <div class="vx-col w-8/12">
        <vs-input
          v-validate="'required|alpha'"
          class="w-full"
          label="Cardholder's Name"
          name="Cardholders Name"
          v-model="firstName"
          @blur="validate"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Cardholders Name')"
          >{{ errors.first("Cardholders Name") }}</span
        >
      </div>
      <!-- Card Number  -->
      <div class="vx-col w-8/12">
        <vs-input
          v-validate="'credit_card'"
          class="w-full"
          label="Card Number"
          name="Card Number"
          v-model="cardNumber"
          icon-pack="feather"
          icon="icon-credit-card"
          icon-no-border
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('Card Number')">{{
          errors.first("Card Number")
        }}</span>
      </div>
      <div class="vs-row w-8/12 flex justify-between px-4 mt-2">
        <!-- Expiry Date  -->
        <div class="vx-col w-3/12">
          <vs-input
            v-validate="'required|alpha_num'"
            class="w-full"
            label="Expiry Date"
            name="Expiry Date"
            v-model="date"
            placeholder="MM / YY"
            @blur="validate"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Expiry Date')"
            >{{ errors.first("Expiry Date") }}</span
          >
        </div>

        <!-- CVC -->
        <div class="vx-col w-3/12">
          <vs-input
            v-validate="'required|digits:3'"
            class="w-full"
            label="CVC"
            name="CVC"
            v-model="cvc"
            icon-pack="feather"
            icon="icon-credit-card"
            icon-no-border
            @blur="validate"
          />
          <span class="text-danger text-sm" v-show="errors.has('CVC')">{{
            errors.first("CVC")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      firstName: "",
      cardNumber: "",
      cvc: "",
    };
  },
  methods: {
    validate() {
      this.$validator.validateAll();
    },
  },
  components: {
    vSelect,
  },
};
</script>
